import type { IColumn } from '@creditflowresearch/uilib/Table/DataTable';
import type { IColumnDefinition } from '@/creditflowresearch/ui/common/components/DataTable/columns/types';
import RowLinkOverlay from './RowLinkOverlay';

import spacesStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';
import styles from './rowLink.module.scss';

interface IRowLinkOptions {
  target?: '_self' | '_blank',
}

const ROW_LINK_COLUMN_BASE = {
  name: 'rowLink',
  title: '',
  width: 'auto' as const,
  minWidth: 0,
  maxWidth: 0,
  className: spacesStyles.pn,
};

const renderOverlay = <T,>(getHref: (row: T) => string | undefined, target: '_self' | '_blank') =>
  ({ row }: { row: T }) => {
    const href = getHref(row);
    return href ? <RowLinkOverlay href={ href } target={ target } /> : null;
  };

export const createRowLinkColumn = <T,>(
  getHref: (row: T) => string | undefined,
  { target = '_self' }: IRowLinkOptions = {},
): IColumn => ({
  ...ROW_LINK_COLUMN_BASE,
  cellCallback: renderOverlay(getHref, target),
});

export const createRowLinkColumnDefinition = <T,>(
  getHref: (row: T) => string | undefined,
  { target = '_self' }: IRowLinkOptions = {},
): IColumnDefinition => ({
  ...ROW_LINK_COLUMN_BASE,
  dataType: 'checkbox',
  cellCallback: renderOverlay(getHref, target),
});

export const aboveRowLinkClassName = styles.aboveRowLink;
